import store from "../../store";
import {createWebSocketSingleton} from "./SocketRouter";

export const isWebSocketSupported = ()=> {
    return ((window.WebSocket !== null && window.WebSocket !== undefined) || (window.MozWebSocket !== null && window.MozWebSocket !== undefined));
};

export const resetWS = () => {
    let stateData = store.getState();
    try{stateData.webSocketData.websocket.close();}catch(err){}
    createWebSocketSingleton();
};
